module.exports = __webpack_public_path__ + "static/media/demonstrate.a742ed60.png";